import { Type } from 'theme/types';
import styled from "styled-components";
import { Text, Title } from "theme/theme";

export const TitleHome = styled(Title)`
  ${({ theme }: Type) => theme?.home?.text?.title}
`

export const TextHome = styled(Text)`
  ${({ theme }: Type) => theme?.home?.text?.text}
`

export const TextHomeSecondary = styled(Text)`
  ${({ theme }: Type) => theme?.home?.text?.textSecondary}
`

export const TextHomeButton = styled(Text)`
  ${({ theme }: Type) => theme?.home?.text?.textButton}
`